<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3949 24H3.53333C2.13367 24 1 22.5293 1 20.7148V4.28389C1 2.47072 2.13367 1 3.53333 1H12.4M15.5667 16.9722L20 12.5L15.5667 8.02778M7.33333 12.4949H20"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>